import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SetService {
  isArray(a: any) {
    return Array.isArray(a);
  }

  getUnion(firstArray = [], secondArray = [], firstObjectKey = null, secondObjectKey = null) {
    if (!this.isArray(firstArray) || !this.isArray(secondArray)) {
      throw Error('Both arguement must be of type array');
    }

    return [
      ...this.getDifference(firstArray, secondArray, firstObjectKey, secondObjectKey),
      ...secondArray,
    ];
  }

  // objectKeys are keys to compare objects and if null then
  // the corresponding array will be considered as flat array
  // otherwise as array of object
  getIntersection(
    firstArray = [],
    secondArray = [],
    firstObjectKey = null,
    secondObjectKey = null
  ) {
    if (!this.isArray(firstArray) || !this.isArray(secondArray)) {
      throw Error('Both arguement must be of type array');
    }

    return firstArray.filter(e1 =>
      secondArray.some(
        e2 =>
          (firstObjectKey ? e1[firstObjectKey] : e1) ===
          (secondObjectKey ? e2[secondObjectKey] : e2)
      )
    );
  }

  getDifference(firstArray = [], secondArray = [], firstObjectKey = null, secondObjectKey = null) {
    if (!this.isArray(firstArray) || !this.isArray(secondArray)) {
      throw Error('Both arguement must be of type array');
    }

    return firstArray.filter(e1 =>
      secondArray.every(
        e2 =>
          (firstObjectKey ? e1[firstObjectKey] : e1) !==
          (secondObjectKey ? e2[secondObjectKey] : e2)
      )
    );
  }
}
